import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Componente de tabela para exibição de itens do dicionário
 * Exibe colunas COD e DESCRIÇÃO com seleção de linha
 */
export default function DicionarioTable({
  itens = [],
  selectedIndex = 0,
  onSelectItem,
  isLoading = false,
  maxHeight = 300,
}) {
  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: 200 }}
      >
        <span className="text-muted">Carregando...</span>
      </div>
    );
  }

  if (!itens || itens.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center border"
        style={{ height: 200, backgroundColor: '#f8f9fa' }}
      >
        <span className="text-muted">Nenhum item cadastrado</span>
      </div>
    );
  }

  return (
    <div
      style={{
        maxHeight,
        overflowY: 'auto',
        border: '1px solid #dee2e6',
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      <Table
        bordered
        hover
        size="sm"
        style={{
          marginBottom: 0,
          fontSize: '0.85rem',
        }}
      >
        <thead
          style={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#008080',
            color: 'white',
            zIndex: 1,
          }}
        >
          <tr>
            <th style={{ width: 70, textAlign: 'center' }}>COD</th>
            <th>DESCRIÇÃO</th>
          </tr>
        </thead>
        <tbody>
          {itens.map((item, index) => (
            <tr
              key={`${item.codigo}-${index}`}
              onClick={() => onSelectItem && onSelectItem(index)}
              className={selectedIndex === index ? 'table-primary' : ''}
              style={{
                cursor: 'pointer',
                backgroundColor:
                  selectedIndex === index ? '#cce5ff' : 'transparent',
              }}
            >
              <td
                style={{
                  textAlign: 'center',
                  fontWeight: selectedIndex === index ? 'bold' : 'normal',
                }}
              >
                {item.codigo}
              </td>
              <td
                style={{
                  fontWeight: selectedIndex === index ? 'bold' : 'normal',
                }}
              >
                {item.descricao}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

DicionarioTable.propTypes = {
  itens: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      descricao: PropTypes.string,
    })
  ),
  selectedIndex: PropTypes.number,
  onSelectItem: PropTypes.func,
  isLoading: PropTypes.bool,
  maxHeight: PropTypes.number,
};
